import { useEffect } from "react";

import { useWorkspaceBranding } from "@/hooks/use-workspaces";

// Mounted once at the app root (outside the router) so the tab title reflects
// the main workspace's name on every page, login included.
export function BrandingSync() {
  const { data } = useWorkspaceBranding();

  useEffect(() => {
    document.title = data?.name || "JAM Coffee & Bakery";
  }, [data]);

  return null;
}
